import { render, staticRenderFns } from "./AvenantEdit.vue?vue&type=template&id=0683c69a&scoped=true"
import script from "./AvenantEdit.vue?vue&type=script&lang=ts"
export * from "./AvenantEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0683c69a",
  null
  
)

export default component.exports